import { render, staticRenderFns } from "./formBuilder2.vue?vue&type=template&id=f30d7a70&scoped=true&"
import script from "./formBuilder2.vue?vue&type=script&lang=js&"
export * from "./formBuilder2.vue?vue&type=script&lang=js&"
import style0 from "./formBuilder2.vue?vue&type=style&index=0&id=f30d7a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30d7a70",
  null
  
)

export default component.exports